<template>
  <div class="bannerof" :style="{ backgroundImage: `url('${Imgsrc}')` }">
    <div class="banner_txt">
      <div class="banner_title">
        {{ title }}
      </div>
      <div class="banner_subtitle">
        {{ subtitle }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bannerof",
  data() {
    return {};
  },
  props: {
    Imgsrc: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.bannerof {
  width: 100%;
  height: 458px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  position: relative;
  .banner_txt {
    position: absolute;
    z-index: 3;
    left: 339px;
    top: 160px;
  
    font-weight: bold;
    .banner_title {
      font-size: 56px;
      margin-bottom: 10px;
    }
    .banner_subtitle {
      font-size: 24px;
    }
  }
}
</style>
